module.exports = __webpack_public_path__ + "img/H3.7a0b75af.png";